module.exports = __webpack_public_path__ + "img/badge@2x.03946c72.png";